import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PRIMARY_COLOR = '#ff3975';

export const ConfirmationDialog = ({ open, onClose, onConfirm }: ConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Open in new tab</DialogTitle>
      <DialogContent>Clicking confirm will open this link in a new tab. Would you like to continue?</DialogContent>
      <DialogActions>
        <Button style={{ color: PRIMARY_COLOR }} onClick={onClose}>
          Cancel
        </Button>
        <Button style={{ color: PRIMARY_COLOR }} onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
